/**
 * 도전 과제. 소스는 `achievements.json`.
 */

import seed from './achievements.json';
import { emitDataReloadSoon, replaceArray, replaceRecord, requireRecord } from './catalog';

export type AchieveUnlock =
  | { kind: 'kills'; monsterId: string; count: number }
  | { kind: 'killsAny'; count: number }
  | { kind: 'level'; level: number }
  | { kind: 'meso'; amount: number }
  | { kind: 'maxCombo'; count: number }
  | { kind: 'quest'; questId: string };

export interface AchieveDef {
  id: string;
  name: string;
  hint: string;
  unlock: AchieveUnlock;
}

export const ACHIEVE_ORDER: string[] = [...seed.ACHIEVE_ORDER];
export const ACHIEVEMENTS: Record<string, AchieveDef> = structuredClone(seed.ACHIEVEMENTS) as Record<
  string,
  AchieveDef
>;

export function getAchieve(id: string): AchieveDef | undefined {
  return ACHIEVEMENTS[id];
}

export function isAchieveEarned(
  def: AchieveDef,
  ctx: { level: number; meso: number; maxCombo: number; kills: Record<string, number>; quests: Record<string, { status: string }> },
): boolean {
  const u = def.unlock;
  if (u.kind === 'level') return ctx.level >= u.level;
  if (u.kind === 'meso') return ctx.meso >= u.amount;
  if (u.kind === 'maxCombo') return ctx.maxCombo >= u.count;
  if (u.kind === 'kills') return (ctx.kills[u.monsterId] ?? 0) >= u.count;
  if (u.kind === 'killsAny') {
    let n = 0;
    for (const v of Object.values(ctx.kills)) n += v;
    return n >= u.count;
  }
  return ctx.quests[u.questId]?.status === 'done';
}

export function applyAchievements(raw: unknown): void {
  const data = requireRecord(raw, 'achievements.json');
  if (Array.isArray(data.ACHIEVE_ORDER)) replaceArray(ACHIEVE_ORDER, data.ACHIEVE_ORDER as string[]);
  replaceRecord(
    ACHIEVEMENTS,
    structuredClone(requireRecord(data.ACHIEVEMENTS, 'ACHIEVEMENTS')) as Record<string, AchieveDef>,
  );
}

if (import.meta.hot) {
  import.meta.hot.accept('./achievements.json', (mod) => {
    if (!mod?.default) return;
    applyAchievements(mod.default);
    emitDataReloadSoon();
  });
}
